// extracted by mini-css-extract-plugin
export default {"pageWidth":"1920px","pageHeight":"1080px"};